import {ActionTree} from "vuex";
import {SmsFilterItem, SmsFiltersState} from "@/store/sms/filters/types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<SmsFiltersState, RootState> = {
  getSmsFilters: ({commit}, data) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/sms/filters', params: data})
        .then(resp => {
          commit('setSmsFilters', resp.data.filters);
          resolve(resp?.data ?? [])
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getSmsFilterItem: ({commit}, id:number) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/sms/filters/${id}`})
        .then((resp: any) => {
          let smsFilterItem = <SmsFilterItem>resp.data;
          smsFilterItem.id = id;
          commit('setSmsFilterItem', smsFilterItem);
          resolve(smsFilterItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  saveSmsFilter: ({commit, dispatch}, data:SmsFilterItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: `/acapi/sms/filters/${data.id ?? ''}`,
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getSmsFilters');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deleteSmsFilter: ({commit, dispatch}, data:SmsFilterItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/sms/filters/${data.id}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getSmsFilters');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
}